import PropTypes from 'prop-types';

const DialIcon = ({ fill, width = '20', height = '20', className = '' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 100 100'
    fill={fill}
    width={width}
    height={height}
    className={className}
  >
    <path d='M94.077,80.619C88.979,92.841,77.026,94.983,73.12,94.983c-1.147,0-19.01,0.947-44.688-23.41  C7.767,51.971,5.242,30.892,5.022,26.887C4.808,22.986,5.925,13.2,19.387,5.929c1.668-0.901,4.975-1.3,5.829-0.446  c0.379,0.379,11.678,18.972,11.975,19.588c0.297,0.615,0.446,1.221,0.446,1.815c0,0.849-0.605,1.911-1.816,3.185  c-1.21,1.274-2.526,2.442-3.949,3.503c-1.423,1.062-2.739,2.187-3.95,3.376c-1.21,1.188-1.815,2.166-1.815,2.93  c0.082,1.983,1.707,9.086,14.086,19.963C52.574,70.723,58.538,73.788,59.111,74c0.574,0.212,1.051,0.317,1.433,0.317  c0.765,0,1.742-0.604,2.931-1.814c1.188-1.211,5.185-6.689,6.459-7.9c1.274-1.209,2.336-1.814,3.186-1.814  c0.594,0,1.199,0.148,1.814,0.445c0.616,0.297,19.233,11.191,19.589,11.555C95.489,75.779,94.807,78.869,94.077,80.619' />
  </svg>
);

DialIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
};

export default DialIcon;
